export const blockIconsMapsSouthNew = (
	<span className='material-symbols-outlined'>south</span>
);
